var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-typeahead-bootstrap',{attrs:{"value":_vm.value,"data":_vm.pws_list,"minMatchingChars":3},on:{"input":function($event){return _vm.onSearchPWS($event)},"hit":function($event){return _vm.setPWS($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }